"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrancheStatus = exports.TobaccoClass = exports.State = exports.RothIRA = exports.RiderType = exports.RefundType = exports.RateCode = exports.QualifiedMarketType = exports.ProductType = exports.ProductCode = exports.PremiumDiscountType = exports.PolicyDocType = exports.PeriodCertainUnit = exports.PaymentFrequency = exports.OccupationClass = exports.NonQualifiedMarketType = exports.NetOrGross = exports.MedicalClass = exports.MarketType = exports.LoanActivityType = exports.IBFPaymentFrequency = exports.Gender = exports.FinancialClass = exports.DividendOption = exports.DisabilityProductType = exports.CoveredRoleClassification = exports.CostBasisType = exports.CollectionAction = exports.ClaimAction = exports.BusinessType = exports.BenefitCode = exports.BeneficiaryClassification = exports.AutoWithdrawalType = exports.AnnuityReductionOnDeathRatio = exports.AnnuityReductionOnDeathOption = exports.AnnuityProductType = exports.AnnuityOption = exports.AccountType = void 0;
var AccountType;
(function (AccountType) {
    AccountType["checking"] = "checking";
    AccountType["savings"] = "savings";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var AnnuityOption;
(function (AnnuityOption) {
    AnnuityOption["Joint"] = "Joint";
    AnnuityOption["Single"] = "Single";
})(AnnuityOption = exports.AnnuityOption || (exports.AnnuityOption = {}));
var AnnuityProductType;
(function (AnnuityProductType) {
    AnnuityProductType["DIA"] = "DIA";
    AnnuityProductType["FDA"] = "FDA";
    AnnuityProductType["SPIA"] = "SPIA";
})(AnnuityProductType = exports.AnnuityProductType || (exports.AnnuityProductType = {}));
/** For a joint annuitant policy with reduction on death option enabled, this option specifies which type of death is covered. */
var AnnuityReductionOnDeathOption;
(function (AnnuityReductionOnDeathOption) {
    AnnuityReductionOnDeathOption["Either"] = "Either";
    AnnuityReductionOnDeathOption["Primary"] = "Primary";
})(AnnuityReductionOnDeathOption = exports.AnnuityReductionOnDeathOption || (exports.AnnuityReductionOnDeathOption = {}));
/** Indicates how much annuity payment is reduce after one annuitant death. */
var AnnuityReductionOnDeathRatio;
(function (AnnuityReductionOnDeathRatio) {
    AnnuityReductionOnDeathRatio["Half"] = "Half";
    AnnuityReductionOnDeathRatio["ThreeQuarters"] = "ThreeQuarters";
    AnnuityReductionOnDeathRatio["TwoThirds"] = "TwoThirds";
})(AnnuityReductionOnDeathRatio = exports.AnnuityReductionOnDeathRatio || (exports.AnnuityReductionOnDeathRatio = {}));
var AutoWithdrawalType;
(function (AutoWithdrawalType) {
    AutoWithdrawalType["FixedAmount"] = "FixedAmount";
    AutoWithdrawalType["Interest"] = "Interest";
    AutoWithdrawalType["MaxFree"] = "MaxFree";
    AutoWithdrawalType["Percentage"] = "Percentage";
    AutoWithdrawalType["RequiredMinDistribution"] = "RequiredMinDistribution";
})(AutoWithdrawalType = exports.AutoWithdrawalType || (exports.AutoWithdrawalType = {}));
var BeneficiaryClassification;
(function (BeneficiaryClassification) {
    BeneficiaryClassification["Contingent"] = "Contingent";
    BeneficiaryClassification["Primary"] = "Primary";
})(BeneficiaryClassification = exports.BeneficiaryClassification || (exports.BeneficiaryClassification = {}));
var BenefitCode;
(function (BenefitCode) {
    BenefitCode["AccidentalDeath"] = "AccidentalDeath";
    BenefitCode["Adbr"] = "Adbr";
    BenefitCode["CIR"] = "CIR";
    BenefitCode["Death"] = "Death";
    BenefitCode["GIR"] = "GIR";
    BenefitCode["Health"] = "Health";
    BenefitCode["Plus"] = "Plus";
    BenefitCode["ROP"] = "ROP";
    BenefitCode["TIR"] = "TIR";
    BenefitCode["Waiver"] = "Waiver";
})(BenefitCode = exports.BenefitCode || (exports.BenefitCode = {}));
var BusinessType;
(function (BusinessType) {
    BusinessType["business"] = "business";
    BusinessType["personal"] = "personal";
})(BusinessType = exports.BusinessType || (exports.BusinessType = {}));
var ClaimAction;
(function (ClaimAction) {
    ClaimAction["Approve"] = "Approve";
    ClaimAction["Deny"] = "Deny";
    ClaimAction["Initiate"] = "Initiate";
    ClaimAction["Terminate"] = "Terminate";
})(ClaimAction = exports.ClaimAction || (exports.ClaimAction = {}));
var CollectionAction;
(function (CollectionAction) {
    CollectionAction["None"] = "None";
    CollectionAction["Pause"] = "Pause";
    CollectionAction["Resume"] = "Resume";
})(CollectionAction = exports.CollectionAction || (exports.CollectionAction = {}));
/** Indicate types of cost basis. */
var CostBasisType;
(function (CostBasisType) {
    CostBasisType["Both"] = "Both";
    CostBasisType["In"] = "In";
    CostBasisType["Out"] = "Out";
})(CostBasisType = exports.CostBasisType || (exports.CostBasisType = {}));
var CoveredRoleClassification;
(function (CoveredRoleClassification) {
    CoveredRoleClassification["Joint"] = "Joint";
    CoveredRoleClassification["Primary"] = "Primary";
})(CoveredRoleClassification = exports.CoveredRoleClassification || (exports.CoveredRoleClassification = {}));
var DisabilityProductType;
(function (DisabilityProductType) {
    DisabilityProductType["ShortTermDisability"] = "ShortTermDisability";
})(DisabilityProductType = exports.DisabilityProductType || (exports.DisabilityProductType = {}));
var DividendOption;
(function (DividendOption) {
    DividendOption["Accumulate"] = "Accumulate";
    DividendOption["Cash"] = "Cash";
    DividendOption["PRCash"] = "PRCash";
    DividendOption["PRPUA"] = "PRPUA";
    DividendOption["PUA"] = "PUA";
})(DividendOption = exports.DividendOption || (exports.DividendOption = {}));
var FinancialClass;
(function (FinancialClass) {
    FinancialClass["High"] = "High";
    FinancialClass["Low"] = "Low";
})(FinancialClass = exports.FinancialClass || (exports.FinancialClass = {}));
var Gender;
(function (Gender) {
    Gender["F"] = "F";
    Gender["M"] = "M";
    Gender["N"] = "N";
})(Gender = exports.Gender || (exports.Gender = {}));
var IBFPaymentFrequency;
(function (IBFPaymentFrequency) {
    IBFPaymentFrequency["Annual"] = "Annual";
    IBFPaymentFrequency["Fractional"] = "Fractional";
    IBFPaymentFrequency["Mixed"] = "Mixed";
    IBFPaymentFrequency["Monthly"] = "Monthly";
    IBFPaymentFrequency["Quarterly"] = "Quarterly";
    IBFPaymentFrequency["SemiAnnual"] = "SemiAnnual";
})(IBFPaymentFrequency = exports.IBFPaymentFrequency || (exports.IBFPaymentFrequency = {}));
/** Indicate the various types of loan events. */
var LoanActivityType;
(function (LoanActivityType) {
    LoanActivityType["Loan"] = "Loan";
    LoanActivityType["LoanInterestCapitalization"] = "LoanInterestCapitalization";
    LoanActivityType["LoanPayment"] = "LoanPayment";
})(LoanActivityType = exports.LoanActivityType || (exports.LoanActivityType = {}));
/** Annuity policy market type for lookup and tax purposes. */
var MarketType;
(function (MarketType) {
    MarketType["CustodialIRA"] = "CustodialIRA";
    MarketType["CustodialQLAC"] = "CustodialQLAC";
    MarketType["IRA"] = "IRA";
    MarketType["InheritedIRA"] = "InheritedIRA";
    MarketType["Keogh"] = "Keogh";
    MarketType["MoneyPurchasePensionPlan"] = "MoneyPurchasePensionPlan";
    MarketType["NonQualified"] = "NonQualified";
    MarketType["NonQualifiedDeferredCompensation"] = "NonQualifiedDeferredCompensation";
    MarketType["PensionPlan"] = "PensionPlan";
    MarketType["ProfitSharingPlan"] = "ProfitSharingPlan";
    MarketType["QLAC"] = "QLAC";
    MarketType["RothIRA"] = "RothIRA";
    MarketType["SEPIRA"] = "SEPIRA";
    MarketType["TargetBenefitPlan"] = "TargetBenefitPlan";
    MarketType["TraditionalIRA"] = "TraditionalIRA";
    MarketType["_401k"] = "_401k";
})(MarketType = exports.MarketType || (exports.MarketType = {}));
var MedicalClass;
(function (MedicalClass) {
    MedicalClass["HA"] = "HA";
    MedicalClass["HB"] = "HB";
    MedicalClass["HC"] = "HC";
})(MedicalClass = exports.MedicalClass || (exports.MedicalClass = {}));
var NetOrGross;
(function (NetOrGross) {
    NetOrGross["Gross"] = "Gross";
    NetOrGross["Net"] = "Net";
})(NetOrGross = exports.NetOrGross || (exports.NetOrGross = {}));
var NonQualifiedMarketType;
(function (NonQualifiedMarketType) {
    NonQualifiedMarketType["NonQualified"] = "NonQualified";
    NonQualifiedMarketType["NonQualifiedDeferredCompensation"] = "NonQualifiedDeferredCompensation";
    NonQualifiedMarketType["RothIRA"] = "RothIRA";
})(NonQualifiedMarketType = exports.NonQualifiedMarketType || (exports.NonQualifiedMarketType = {}));
var OccupationClass;
(function (OccupationClass) {
    OccupationClass["OA"] = "OA";
    OccupationClass["OB"] = "OB";
    OccupationClass["OC"] = "OC";
    OccupationClass["OD"] = "OD";
})(OccupationClass = exports.OccupationClass || (exports.OccupationClass = {}));
var PaymentFrequency;
(function (PaymentFrequency) {
    PaymentFrequency["Annual"] = "Annual";
    PaymentFrequency["Mixed"] = "Mixed";
    PaymentFrequency["Monthly"] = "Monthly";
    PaymentFrequency["OneTimePayment"] = "OneTimePayment";
    PaymentFrequency["Quarterly"] = "Quarterly";
    PaymentFrequency["SemiAnnual"] = "SemiAnnual";
})(PaymentFrequency = exports.PaymentFrequency || (exports.PaymentFrequency = {}));
var PeriodCertainUnit;
(function (PeriodCertainUnit) {
    PeriodCertainUnit["Month"] = "Month";
})(PeriodCertainUnit = exports.PeriodCertainUnit || (exports.PeriodCertainUnit = {}));
var PolicyDocType;
(function (PolicyDocType) {
    PolicyDocType["DisabilityPolicyPacket"] = "DisabilityPolicyPacket";
})(PolicyDocType = exports.PolicyDocType || (exports.PolicyDocType = {}));
var PremiumDiscountType;
(function (PremiumDiscountType) {
    PremiumDiscountType["LifeSale"] = "LifeSale";
    PremiumDiscountType["Spouse"] = "Spouse";
})(PremiumDiscountType = exports.PremiumDiscountType || (exports.PremiumDiscountType = {}));
var ProductCode;
(function (ProductCode) {
    ProductCode["AgeUpDIA"] = "AgeUpDIA";
    ProductCode["CASRE"] = "CASRE";
    ProductCode["CASREC"] = "CASREC";
    ProductCode["CASSV"] = "CASSV";
    ProductCode["CASTerm"] = "CASTerm";
    ProductCode["CASTermECP"] = "CASTermECP";
    ProductCode["CPL10"] = "CPL10";
    ProductCode["CPL10A"] = "CPL10A";
    ProductCode["CPL12"] = "CPL12";
    ProductCode["CPL15"] = "CPL15";
    ProductCode["CPL15A"] = "CPL15A";
    ProductCode["CPL20"] = "CPL20";
    ProductCode["CPL20A"] = "CPL20A";
    ProductCode["CPL65"] = "CPL65";
    ProductCode["CPL65A"] = "CPL65A";
    ProductCode["CPL100"] = "CPL100";
    ProductCode["CPL100A"] = "CPL100A";
    ProductCode["CreditCard"] = "CreditCard";
    ProductCode["ET03"] = "ET03";
    ProductCode["ET10"] = "ET10";
    ProductCode["HavenAD"] = "HavenAD";
    ProductCode["HavenDI"] = "HavenDI";
    ProductCode["HavenSPR"] = "HavenSPR";
    ProductCode["HavenSPW"] = "HavenSPW";
    ProductCode["HavenTerm"] = "HavenTerm";
    ProductCode["HavenTerm2"] = "HavenTerm2";
    ProductCode["HavenTermSI"] = "HavenTermSI";
    ProductCode["HavenTermSIT"] = "HavenTermSIT";
    ProductCode["LongTermLoan"] = "LongTermLoan";
    ProductCode["MMDirectTerm"] = "MMDirectTerm";
    ProductCode["MMDirectTermECP"] = "MMDirectTermECP";
    ProductCode["MMOPMTerm"] = "MMOPMTerm";
    ProductCode["MMOPMTermAPT80"] = "MMOPMTermAPT80";
    ProductCode["MMTRADTerm"] = "MMTRADTerm";
    ProductCode["MMTRADTermECP"] = "MMTRADTermECP";
    ProductCode["MMTRADWL20"] = "MMTRADWL20";
    ProductCode["MMTRADWL65"] = "MMTRADWL65";
    ProductCode["MMTRADWL100"] = "MMTRADWL100";
    ProductCode["ShortTermLoan"] = "ShortTermLoan";
})(ProductCode = exports.ProductCode || (exports.ProductCode = {}));
var ProductType;
(function (ProductType) {
    ProductType["Creditor"] = "Creditor";
    ProductType["DIA"] = "DIA";
    ProductType["DecreasingTerm"] = "DecreasingTerm";
    ProductType["FDA"] = "FDA";
    ProductType["SPIA"] = "SPIA";
    ProductType["ShortTermDisability"] = "ShortTermDisability";
    ProductType["Term"] = "Term";
    ProductType["Whole"] = "Whole";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var QualifiedMarketType;
(function (QualifiedMarketType) {
    QualifiedMarketType["CustodialIRA"] = "CustodialIRA";
    QualifiedMarketType["CustodialQLAC"] = "CustodialQLAC";
    QualifiedMarketType["IRA"] = "IRA";
    QualifiedMarketType["InheritedIRA"] = "InheritedIRA";
    QualifiedMarketType["Keogh"] = "Keogh";
    QualifiedMarketType["MoneyPurchasePensionPlan"] = "MoneyPurchasePensionPlan";
    QualifiedMarketType["PensionPlan"] = "PensionPlan";
    QualifiedMarketType["ProfitSharingPlan"] = "ProfitSharingPlan";
    QualifiedMarketType["QLAC"] = "QLAC";
    QualifiedMarketType["SEPIRA"] = "SEPIRA";
    QualifiedMarketType["TargetBenefitPlan"] = "TargetBenefitPlan";
    QualifiedMarketType["TraditionalIRA"] = "TraditionalIRA";
    QualifiedMarketType["_401k"] = "_401k";
})(QualifiedMarketType = exports.QualifiedMarketType || (exports.QualifiedMarketType = {}));
var RateCode;
(function (RateCode) {
    RateCode["U"] = "U";
})(RateCode = exports.RateCode || (exports.RateCode = {}));
/** How annuity premium refund is paid. */
var RefundType;
(function (RefundType) {
    RefundType["Cash"] = "Cash";
    RefundType["Installment"] = "Installment";
    RefundType["LifeWithPeriodCertain"] = "LifeWithPeriodCertain";
    RefundType["None"] = "None";
    RefundType["PeriodCertainOnly"] = "PeriodCertainOnly";
})(RefundType = exports.RefundType || (exports.RefundType = {}));
var RiderType;
(function (RiderType) {
    RiderType["ALIR"] = "ALIR";
    RiderType["CIR"] = "CIR";
    RiderType["GIR"] = "GIR";
    RiderType["RTR"] = "RTR";
    RiderType["TIR"] = "TIR";
})(RiderType = exports.RiderType || (exports.RiderType = {}));
var RothIRA;
(function (RothIRA) {
    RothIRA["RothIRA"] = "RothIRA";
})(RothIRA = exports.RothIRA || (exports.RothIRA = {}));
var State;
(function (State) {
    State["AG"] = "AG";
    State["AI"] = "AI";
    State["AK"] = "AK";
    State["AL"] = "AL";
    State["AR"] = "AR";
    State["AZ"] = "AZ";
    State["CA"] = "CA";
    State["CO"] = "CO";
    State["CT"] = "CT";
    State["DC"] = "DC";
    State["DE"] = "DE";
    State["DM"] = "DM";
    State["FL"] = "FL";
    State["GA"] = "GA";
    State["GD"] = "GD";
    State["HI"] = "HI";
    State["IA"] = "IA";
    State["ID"] = "ID";
    State["IL"] = "IL";
    State["IN"] = "IN";
    State["KN"] = "KN";
    State["KS"] = "KS";
    State["KY"] = "KY";
    State["LA"] = "LA";
    State["LC"] = "LC";
    State["MA"] = "MA";
    State["MD"] = "MD";
    State["ME"] = "ME";
    State["MI"] = "MI";
    State["MN"] = "MN";
    State["MO"] = "MO";
    State["MS"] = "MS";
    State["MT"] = "MT";
    State["NA_"] = "NA_";
    State["NC"] = "NC";
    State["ND"] = "ND";
    State["NE"] = "NE";
    State["NH"] = "NH";
    State["NJ"] = "NJ";
    State["NM"] = "NM";
    State["NV"] = "NV";
    State["NY"] = "NY";
    State["OH"] = "OH";
    State["OK"] = "OK";
    State["OR"] = "OR";
    State["PA"] = "PA";
    State["PR"] = "PR";
    State["RI"] = "RI";
    State["SC"] = "SC";
    State["SD"] = "SD";
    State["SX"] = "SX";
    State["TN"] = "TN";
    State["TX"] = "TX";
    State["UT"] = "UT";
    State["VA"] = "VA";
    State["VC"] = "VC";
    State["VG"] = "VG";
    State["VT"] = "VT";
    State["WA"] = "WA";
    State["WI"] = "WI";
    State["WV"] = "WV";
    State["WY"] = "WY";
})(State = exports.State || (exports.State = {}));
var TobaccoClass;
(function (TobaccoClass) {
    TobaccoClass["NT"] = "NT";
    TobaccoClass["T"] = "T";
})(TobaccoClass = exports.TobaccoClass || (exports.TobaccoClass = {}));
var TrancheStatus;
(function (TrancheStatus) {
    TrancheStatus["Cancelled"] = "Cancelled";
    TrancheStatus["NotTaken"] = "NotTaken";
    TrancheStatus["PurchasePending"] = "PurchasePending";
    TrancheStatus["Purchased"] = "Purchased";
})(TrancheStatus = exports.TrancheStatus || (exports.TrancheStatus = {}));
